var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":"2"}},[_c('strong',{staticClass:"ntitlesdark--text fs-1_2"},[_vm._v(_vm._s(_vm.titleInput))])])}
var staticRenderFns = []

export { render, staticRenderFns }